/* eslint-disable @typescript-eslint/ban-ts-comment */

// @ts-ignore
export type URL = globalThis.URL;
// @ts-ignore
export const URL: typeof globalThis.URL = globalThis.URL;
